
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import InvoiceGeneratorDialog from '@/components/Transport/Accounting/InvoiceGeneratorDialog.vue'
import { Invoice } from '@/models/accounting/Invoice'
import Notification from '@/classes/Notification'
import i18n from '@/i18n'
import { generateInvoicePdf, GenerateInvoiceData } from '@/utils/invoice'

@Component({
	components: { InvoiceGeneratorDialog }
})
export default class InvoiceGeneratorDialogWrapper extends Vue {
	@Prop({ required: true })
	show!: boolean

	@Prop({ required: true })
	invoiceId!: string

	@Ref('generatorDialog')
	generatorDialogRef!: InvoiceGeneratorDialog

	invoice: Invoice | null = null
	isLoading: boolean = false
	isGenerating: boolean = false

	async created() {
		await this.loadInvoice()
	}

	@Watch('invoiceId')
	async onInvoiceIdChange() {
		await this.loadInvoice()
	}

	async loadInvoice() {
		if (!this.invoiceId) return
		this.isLoading = true
		try {
			const response = await Invoice.with(['transports', 'transports.documents']).find(this.invoiceId)
			this.invoice = response.getData() as Invoice
		} catch (err) {
            // eslint-disable-next-line
			console.error('Error loading invoice', err)
			await Notification.Error(i18n.t('errors.load_error').toString())
			this.$emit('close')
		} finally {
			this.isLoading = false
		}
	}

	async handleGenerate(receivedData: GenerateInvoiceData | null) {
		if (!this.invoice) return

		try {
			const valid = await this.generatorDialogRef.validate()
			if (!valid) return

			this.isGenerating = true

			const { documentId } = await generateInvoicePdf(this.invoice, receivedData)

			this.$emit('generated', { documentId })
		} catch (err) {
		    // eslint-disable-next-line
			console.error('Error generating invoice PDF', err)
			await Notification.Error(i18n.t('errors.generation_error').toString())
			this.$emit('close')
		} finally {
			this.isGenerating = false
		}
	}
}
